define(function (require) {
	const ORGANIZATION = "organization";
	const PERSONAL = "personal";
	const USER_SESSION = "USER_SESSION";
	return {
		init:function(){
			App.user = App.user ? App.user: {
				isLoggedIn:false,
				isServiceProvider:false,
				hasMultipleProfiles:false,
				hasOrganizationProfiles:false,
				isLoggedInToOrganizationProfile:false,
				organizationName:''
			}
		},
		processUserResponse:function(response, fromRestServices = false){
			this.init();
			App.user.portalMembership = response.id;

			this.processPersonalProfile(response);
			this.processCurrentProfile(response);
			this.processOrganizationProfiles(response);
			this.processAvailableProfiles();
			this.processMFASubscriptions(response);
			this.processSocialIdentity(response);

			//if we're coming from the rest services, we need to store the whole response in the session storage. otherwise, someone read the data from the session and passed it to us.
			if(fromRestServices){
				App.sessionStorage.set( 'CIVICS', USER_SESSION, JSON.stringify(response));//store the whole response as the auth user feature requires it.
			}
		},
		processSocialIdentity:function(response){
			if(response.socialIdentity){
				App.user.socialIdentity = response.socialIdentity;
			}  else if (response.baseUser && response.baseUser.socialIdentity) {
				App.user.socialIdentity = response.baseUser.socialIdentity;
			}
		},
		processPersonalProfile:function(response){
			App.user.isLoggedInToOrganizationProfile = response.baseUser && response.baseUser.id && response.baseUser.id>1000;
			App.user.personalProfile = App.user.isLoggedInToOrganizationProfile ? response.baseUser.contactId : response.contactId;
			App.user.userName =  App.user.isLoggedInToOrganizationProfile ? response.baseUser.userName : response.userName
			this.defaultProfileId = App.user.isLoggedInToOrganizationProfile ? response.baseUser.defaultProfile : response.defaultProfile;

		},
		processCurrentProfile:function(response){
			this.currentProfile = response.contactId;
			if(this.currentProfile==null){
				return;
			}
			App.user.id = this.currentProfile.id
			App.user.isLoggedIn = this.currentProfile.id>1;
			App.user.contactId = this.currentProfile;
			App.user.email = this.currentProfile.eMailAddress;
			App.user.isServiceProvider = this.currentProfile.isServiceProvider === true;

			if (App.user.isLoggedInToOrganizationProfile) {
				App.user.organizationCreatedDate = response.organizationCreatedDate;
			}

			App.user.roles = response.roles;

		},
		processOrganizationProfiles:function(response){
			let organizations = App.user.isLoggedInToOrganizationProfile ? response.baseUser.organizations : response.organizations;
			organizations = organizations ? organizations : [];
			if(organizations.length==0 && !App.user.isLoggedInToOrganizationProfile){
				App.user.hasMultipleProfiles = false;
				App.user.hasMultipleUsableProfiles = false;
				App.user.hasOrganizationProfiles = false;
				return;
			}
			//add the current profile to the list of organizations if we're logged in to an org
			if(App.user.isLoggedInToOrganizationProfile){
				const currentId = this.currentProfile.id;
    			const idExists = organizations.some(profile => profile.id === currentId);
				
				if(!idExists) {
					organizations.push({
					id: currentId,
					name: this.currentProfile.identity.lastName
					});
				}
		
				App.user.organizationName = Handlebars.helpers['global:sanitize'](this.currentProfile.identity.lastName || '', { hash: { allowedTags: '' } });
			}
			App.user.hasMultipleProfiles = true;
			App.user.organizations = organizations;
			App.user.hasOrganizationProfiles = true;
		},
		processAvailableProfiles:function(){
			App.user.profiles = [];
			if(!App.user.isLoggedIn){
				//not logged in, just set empty array
				return;
			}
			let defaultFound = false;
			//add the personal profile
			App.user.profiles.push({
				type:PERSONAL,
				isPersonalProfile:true,
				isOrganizationProfile:false,
				isCurrentProfile: this.currentProfile.id === App.user.personalProfile.id,
				name:App.user.personalProfile.identity.fullName,
				default:false,//we default the personal profile to be the default if we don't find a default in the loop below.
			});

			if (typeof App.user.organizations !== 'undefined') {
				App.user.organizations.forEach((org)=>{
					App.user.profiles.push({
						id: org.id,
						type:ORGANIZATION,
						isPersonalProfile:false,
						isOrganizationProfile:true,
						isCurrentProfile: org.id === this.currentProfile.id,
						name:Handlebars.helpers['global:sanitize'](org.name || '', { hash: { allowedTags: '' } }),
						default:org.id == this.defaultProfileId,
					});
					if(org.id == this.defaultProfileId){
						defaultFound = true;
					}
				});
			}

			if(defaultFound === false){
				//set the first one as default for now. it should be the personal profile, unless they don't have one active.
				App.user.profiles[0].default = true;
			}
			this.sortProfiles();
		},
		processMFASubscriptions:function(response){
			App.user.mfaSubscriptions =  App.user.isLoggedInToOrganizationProfile ? response.baseUser.mfaSubscriptions : response.mfaSubscriptions;
		},
		sortProfiles:function(){
			App.user.profiles.sort((a,b)=>{
				if(a.isCurrentProfile){
					return -1;
				}
				if(b.isCurrentProfile){
					return 1;
				}
				if(a.type === PERSONAL){//sort personal profiles to last
					return 1;
				}
				if(b.type === PERSONAL){//sort personal profiles to last
					return -1;
				}
				if(a.default){
					return -1;
				}
				if(b.default){
					return 1;
				}
				if(a.name && b.name){//this should never fail. but just in case.
					//locale compare takes into account the STANDARD case sensitive/insensitive for a locale. 
					//We do not need to check case when using this.
					return  a.name.localeCompare(b.name)
				}

				return 0;
			});
		},
		setParameter:function(name, value){
			App.user[name] = value;
		}
	}
});
